import { OrderStatusEnum } from "@/config/apiClient.types";
import { tolgee } from "@/providers/TranslationProvider";

export const STATUS_TRANSLATION_KEYS: Partial<Record<OrderStatusEnum, string>> =
  {
    [OrderStatusEnum.TO_STUDY]:
      "order.mediumDetails.stepConfiguration.selectHeaderToStudy",
    [OrderStatusEnum.DRAFT]:
      "order.mediumDetails.stepConfiguration.selectHeaderDraft",
    [OrderStatusEnum.IN_PROGRESS]:
      "order.mediumDetails.stepConfiguration.selectHeaderInProgress",
  };

export const getSelectHeaderOptionsText = (status: OrderStatusEnum): string => {
  const key = STATUS_TRANSLATION_KEYS[status];
  return key ? tolgee.t(key) : "";
};
